// frontend/src/components/CookieConsentBanner.js
import React, { useState, useEffect } from 'react';
import userSettingsService from '../services/userSettingsService';

const CookieConsentBanner = () => {
    const [showBanner, setShowBanner] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [consent, setConsent] = useState({
        functional: true, // За замовчуванням дозволено (необхідні)
        analytics: false,
        marketing: false
    });

    useEffect(() => {
        checkConsentStatus();
    }, []);

    const checkConsentStatus = async () => {
        try {
            const userConsent = await userSettingsService.getUserConsent();
            
            if (!userConsent) {
                // Показуємо банер, якщо згоди немає
                setShowBanner(true);
            } else {
                setConsent(userConsent);
            }
        } catch (error) {
            console.error('Помилка перевірки згоди:', error);
            setShowBanner(true);
        }
    };

    const handleAcceptAll = async () => {
        const fullConsent = {
            functional: true,
            analytics: true,
            marketing: true
        };

        const result = await userSettingsService.setUserConsent(fullConsent);
        
        if (result.success) {
            setConsent(fullConsent);
            setShowBanner(false);
            setShowSettings(false);
        }
    };

    const handleAcceptNecessary = async () => {
        const necessaryConsent = {
            functional: true,
            analytics: false,
            marketing: false
        };

        const result = await userSettingsService.setUserConsent(necessaryConsent);
        
        if (result.success) {
            setConsent(necessaryConsent);
            setShowBanner(false);
            setShowSettings(false);
        }
    };

    const handleCustomConsent = async () => {
        const result = await userSettingsService.setUserConsent(consent);
        
        if (result.success) {
            setShowBanner(false);
            setShowSettings(false);
        }
    };

    const handleToggleConsent = (type) => {
        if (type === 'functional') {
            // Функціональні cookies не можна вимкнути (необхідні)
            return;
        }
        
        setConsent(prev => ({
            ...prev,
            [type]: !prev[type]
        }));
    };

    if (!showBanner) {
        return null;
    }

    return (
        <div className="cookie-consent-banner">
            <div className="cookie-banner-content">
                {!showSettings ? (
                    // Основний банер
                    <div className="cookie-banner-main">
                        <div className="cookie-banner-text">
                            <h3>🍪 Використання Cookies</h3>
                            <p>
                                Ми використовуємо cookies для запам'ятовування вашого імені в кімнатах та покращення роботи сервісу. 
                                Функціональні cookies необхідні для коректної роботи додатку.
                            </p>
                        </div>
                        <div className="cookie-banner-actions">
                            <button 
                                className="btn-cookie btn-secondary"
                                onClick={() => setShowSettings(true)}
                            >
                                Налаштування
                            </button>
                            <button 
                                className="btn-cookie btn-tertiary"
                                onClick={handleAcceptNecessary}
                            >
                                Тільки необхідні
                            </button>
                            <button 
                                className="btn-cookie btn-primary"
                                onClick={handleAcceptAll}
                            >
                                Прийняти всі
                            </button>
                        </div>
                    </div>
                ) : (
                    // Детальні налаштування
                    <div className="cookie-banner-settings">
                        <div className="cookie-banner-header">
                            <h3>🍪 Налаштування Cookies</h3>
                            <button 
                                className="btn-close"
                                onClick={() => setShowSettings(false)}
                                aria-label="Закрити"
                            >
                                ×
                            </button>
                        </div>
                        
                        <div className="cookie-categories">
                            <div className="cookie-category">
                                <div className="cookie-category-header">
                                    <label className="cookie-toggle">
                                        <input
                                            type="checkbox"
                                            checked={consent.functional}
                                            disabled={true}
                                            readOnly
                                        />
                                        <span className="toggle-slider disabled"></span>
                                        <span className="toggle-label">
                                            <strong>Функціональні Cookies</strong>
                                            <span className="required-badge">Необхідні</span>
                                        </span>
                                    </label>
                                </div>
                                <p className="cookie-category-description">
                                    Необхідні для збереження вашого імені в кімнатах та основної функціональності додатку.
                                </p>
                            </div>

                            <div className="cookie-category">
                                <div className="cookie-category-header">
                                    <label className="cookie-toggle">
                                        <input
                                            type="checkbox"
                                            checked={consent.analytics}
                                            onChange={() => handleToggleConsent('analytics')}
                                        />
                                        <span className="toggle-slider"></span>
                                        <span className="toggle-label">
                                            <strong>Аналітичні Cookies</strong>
                                        </span>
                                    </label>
                                </div>
                                <p className="cookie-category-description">
                                    Допомагають нам зрозуміти, як використовується додаток, для покращення сервісу.
                                </p>
                            </div>

                            <div className="cookie-category">
                                <div className="cookie-category-header">
                                    <label className="cookie-toggle">
                                        <input
                                            type="checkbox"
                                            checked={consent.marketing}
                                            onChange={() => handleToggleConsent('marketing')}
                                        />
                                        <span className="toggle-slider"></span>
                                        <span className="toggle-label">
                                            <strong>Маркетингові Cookies</strong>
                                        </span>
                                    </label>
                                </div>
                                <p className="cookie-category-description">
                                    Використовуються для показу релевантної реклами та контенту.
                                </p>
                            </div>
                        </div>

                        <div className="cookie-banner-actions">
                            <button 
                                className="btn-cookie btn-secondary"
                                onClick={() => setShowSettings(false)}
                            >
                                Скасувати
                            </button>
                            <button 
                                className="btn-cookie btn-primary"
                                onClick={handleCustomConsent}
                            >
                                Зберегти налаштування
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CookieConsentBanner;
